import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  IconButton,
  AppBar,
  Toolbar,
  Link,
  Paper, Tooltip
} from '@mui/material';
import {
  LocalPrintshop as PrintIcon,
  ArrowBack as BackIcon,
  Payment as PaymentIcon,
  Send as SendIcon
} from '@mui/icons-material';
import { useReactToPrint } from 'react-to-print';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TableComponent from '../../../atoms/TableComponent/BookingTable';

const AccountGenerateTablePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerms, setSearchTerms] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  // const [showSelectedOnly, setShowSelectedOnly] = useState(false);
  const contentRef = useRef(null);
  const [bookingInfo, setBookingInfo] = useState(null);

const formatDate = (dateString) => {
  if (!dateString) return '';
  const [month, day, year] = dateString.split('-');

  return `${day}/${month}/${year}`;
};

  useEffect(() => {
    if (location.state?.accountData) {
      const formattedData = location.state.accountData.map(item => ({
      ...item,
      PyadDt: formatDate(item.PyadDt)
    }));
      setData(formattedData);
      setFilteredRows(formattedData);
      setBookingInfo(location.state.bookingInfo);
    } else {
      // Fallback to check session storage
      const storedData = sessionStorage.getItem('accountGenerateData');
      if (storedData) {
        try {
          const parsedData = JSON.parse(storedData);
          setData(parsedData);
          setFilteredRows(parsedData);
        } catch (e) {
          console.error('Error parsing stored data:', e);
          setData([]);
          setFilteredRows([]);
        }
      }
    }
  }, [location]);

  // Update filtered rows whenever selection mode or selected rows change
  // useEffect(() => {
  //   if (showSelectedOnly && selectedRows.length > 0) {
  //     console.log("Showing only selected rows:", selectedRows);
  //     // Show only the selected rows
  //     setFilteredRows(selectedRows);
  //   } else if (!showSelectedOnly) {
  //     // Apply normal filters when not in selected-only mode
  //     const filtered = data.filter(row => {
  //       return Object.entries(searchTerms).every(([key, term]) => {
  //         if (!term) return true;
  //         const value = String(row[key] || '').toLowerCase();
  //         return value.includes(String(term).toLowerCase());
  //       });
  //     });
  //     setFilteredRows(filtered);
  //   }
  // }, [showSelectedOnly, selectedRows, data, searchTerms]);

  const columns = [
    { id: 'BookId', label: 'BID', minWidth: 150 },
    { id: 'MonthNm', label: 'Month', minWidth: 150 },
    { id: 'YearNm', label: 'Year', minWidth: 150 },
    { id: 'StdRent', label: 'StdRent', minWidth: 150 },
    { id: 'ExtraRent', label: 'ExtraRent', minWidth: 150 },
    { id: 'FmDisc', label: 'FmDisc', minWidth: 150 },
    { id: 'NetRent', label: 'NetRent', minWidth: 150 },
    { id: 'CouponDisc', label: 'CouponDisc', minWidth: 150 },
    { id: 'EffRent', label: 'EffRent', minWidth: 150 },
    { id: 'PyadAmt', label: 'PyadAmt', minWidth: 150 },
    { id: 'BalPyadAmt', label: 'BalPyadAmt', minWidth: 150 },
    { id: 'PyadDt', label: 'PyDate', minWidth: 150,format: (value) => formatDate(value) }
  ];

  const handlePrint = useReactToPrint({
    content: () => contentRef.current
  });

  const handleSearchChange = (columnId, value) => {
    // if (showSelectedOnly) return; // Prevent searching when showing only selected rows

    setSearchTerms(prev => ({ ...prev, [columnId]: value }));
    setPage(0);
  };

  const handleRowDoubleClick = (row) => {
    // Handle double click if needed
    console.log('Double clicked row:', row);
  };

  const handleMakePayment = () => {
    if (selectedRows.length > 0) {
      console.log("Selected rows for payment advice:", selectedRows);
      // Toggle view to show only selected rows
      // setShowSelectedOnly(true);
    }
  };

  const handleSendPaymentAdvice = () => {
    if (selectedRows.length > 0) {
      console.log('Sending payment advice for:', selectedRows);
      // Here you would implement the actual logic to send payment advice
      alert(`Payment advice being sent for ${selectedRows.length} items`);

      // Optional: Return to normal view after sending
      // setShowSelectedOnly(false);
    }
  };

  // Handle row selection
  const handleSelectRow = (rows) => {
    console.log("Row selection changed:", rows);
    setSelectedRows(rows);
  };

   const handleBackClick = () => {
    if (bookingInfo) {
      navigate(`/renewbooking`, {
        state: {
          BookId: data[0]?.BookId, 
          flag: "R", 
          fromAccGen: true,
          isSubmitted: true,
        }
      });
    } else {
      navigate(-1);
    }
  };

  const Filters = (
    
    <Tooltip title={"Back to the Previous Page"} placement="top">
      <IconButton
        onClick={handleBackClick}
        sx={{
          backgroundColor: '#635bff',
          borderRadius: '50%',
          width: 40,
          height: 40,
          '&:hover': {
            backgroundColor: '#635bff',
          },
          boxShadow: 3,
        }}
      >
        <ArrowBackIcon sx={{ color: 'white' }} />
      </IconButton>
    </Tooltip>

  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Box sx={{ flexGrow: 1 }} ref={contentRef}>
        <TableComponent
          columns={columns}
          FiltersJsx={Filters}
          rows={data}
          filteredRows={filteredRows}
          page={page}
          handleSearchChange={handleSearchChange}
          handleRowDoubleClick={handleRowDoubleClick}
          title="Booking(Pre-Registration)"
          titleMaster="Account Statement"
          handleHomeClick={() => navigate('/dashboard')}
          handleLocationclick={() => navigate('/enquiry/pre-registration')}
          isLoading={false}
          onSelectRow={handleSelectRow}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
        // Disable row selection when in payment advice mode
        // disableSelection={showSelectedOnly}
        />

        {/* Payment Button or Send Link based on mode */}
        <Paper
          sx={{
            width: "90%",
            margin: "0px auto",
            padding: "0px 16px",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center"
          }}
        >

          {/* <Button
            variant="contained"
            color="primary"
            startIcon={<PaymentIcon />}
            onClick={handleMakePayment}
            disabled={selectedRows.length === 0}
            sx={{
              backgroundColor: "#635bff",
              borderRadius: "20px",
              padding: "8px 24px",
              my: 2
            }}
          >
            Generate Payment Advice
          </Button> */}

        </Paper>
      </Box>
    </Box>
  );
};

export default AccountGenerateTablePage;